import { IVaccination, SuggestedVaccination } from "@/types/vaccination";
import { BaseService } from "./base.service";

export class VaccinationsService extends BaseService {
  constructor() {
    super('vaccinations');
  }

  getVaccinations(memberId: string): Promise<IVaccination[]> {
    return this.get<IVaccination[]>(`/${memberId}`);
  }

  async getVaccination(memberId: string, vaccinationId: string) {
    return this.get<IVaccination>(`/${memberId}/${vaccinationId}`);
  }

  addVaccination(memberId: string, vaccination: IVaccination): Promise<IVaccination> {
    return this.post<IVaccination>(`/${memberId}`, vaccination);
  }

  updateVaccination(memberId: string, vaccinationId: string, vaccination: IVaccination): Promise<IVaccination> {
    return this.put<IVaccination>(`/${memberId}/${vaccinationId}`, vaccination);
  }

  deleteVaccination(memberId: string, vaccinationId: string): Promise<IVaccination> {
    return this.delete<IVaccination>(`/${memberId}/${vaccinationId}`);
  }

  async markAsDone(memberId: string, vaccinationId: string): Promise<IVaccination> {
    return await this.put<IVaccination>(`/${memberId}/${vaccinationId}/mark-as-done`);
  }

  async getVaccinationPerAge(memberId: string): Promise<SuggestedVaccination[]> {
    return this.get<SuggestedVaccination[]>(`/${memberId}/per-age`);
  }

}

export const vaccinationsService = new VaccinationsService();